import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { FileText, Plus } from "@phosphor-icons/react";

const STATUSES = ["draft", "sent", "accepted", "declined", "won"];

export default function Quotes() {
  const [quotes, setQuotes] = useState([]);
  const [filter, setFilter] = useState("all");

  const load = async () => {
    const { data } = await api.get("/quotes");
    setQuotes(data || []);
  };
  useEffect(() => { load(); }, []);

  const filtered = filter === "all" ? quotes : quotes.filter((q) => q.status === filter);

  const setStatus = async (id, status) => {
    await api.patch(`/quotes/${id}`, { status });
    load();
  };

  return (
    <div className="space-y-6" data-testid="quotes-page">
      <div className="flex items-end justify-between gap-3 flex-wrap">
        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-muted-foreground">Quotes</div>
          <h1 className="font-display text-4xl font-black tracking-tight mt-1">Quote builder</h1>
        </div>
        <Button asChild className="rounded-sm bg-[var(--uc-primary)] hover:bg-[var(--uc-primary-hover)] text-white" data-testid="new-quote-btn">
          <Link to="/quotes/new"><Plus size={16} className="mr-1" /> New quote</Link>
        </Button>
      </div>

      <div className="flex items-center gap-2 flex-wrap">
        {["all", ...STATUSES].map((s) => (
          <button key={s} onClick={() => setFilter(s)} data-testid={`filter-${s}`}
            className={`text-[10px] uppercase tracking-[0.2em] px-3 py-2 rounded-sm border ${
              filter === s ? "border-[var(--uc-primary)] text-[var(--uc-primary)]" : "border-border text-muted-foreground hover:text-foreground"
            }`}>{s}</button>
        ))}
      </div>

      <Card className="rounded-sm border-border overflow-hidden">
        <table className="w-full text-sm dense">
          <thead className="bg-muted/40 text-left text-[10px] uppercase tracking-[0.2em] text-muted-foreground">
            <tr>
              <th>Quote #</th><th>Customer</th><th>Company</th><th className="text-right">Total</th><th>Status</th><th>Created</th>
            </tr>
          </thead>
          <tbody>
            {filtered.length === 0 && <tr><td colSpan={6} className="py-10 text-center text-muted-foreground">No quotes yet.</td></tr>}
            {filtered.map((q) => (
              <tr key={q.quote_id} className="border-t border-border" data-testid={`quote-${q.quote_number}`}>
                <td className="font-medium">{q.quote_number}</td>
                <td>{q.customer_name}</td>
                <td className="text-muted-foreground">{q.customer_company || "—"}</td>
                <td className="text-right font-display font-bold">${q.total.toFixed(2)}</td>
                <td>
                  <Select value={q.status} onValueChange={(v) => setStatus(q.quote_id, v)}>
                    <SelectTrigger className="w-32 h-8 rounded-sm" data-testid={`status-${q.quote_number}`}>
                      <SelectValue />
                    </SelectTrigger>
                    <SelectContent>
                      {STATUSES.map((s) => <SelectItem key={s} value={s}>{s}</SelectItem>)}
                    </SelectContent>
                  </Select>
                </td>
                <td className="text-muted-foreground text-xs">{q.created_at?.slice(0,10)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </Card>
    </div>
  );
}
